<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="900px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span>Thông tin chi tiết</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row class="mt-2">
            <v-col cols="12">
              <v-text-field
                v-model="item.phone_number"
                label="Số điện thoại"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-if="item.branch"
                v-model="item.branch.name"
                label="Lĩnh vực"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <label>Nội dung</label>
              <quill-editor 
                v-model="item.content"
                :options="editorOption"
                style="min-height:250px;"
              >
              </quill-editor>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Đóng lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        editorOption: {
          placeholder: 'Nhập văn bản ở đây',
        }
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
        }
      }
    },
    methods: {
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
    }
  }
</script>